// const uuid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
export const uuid = () => "00-0-0-0-000".replace(/0/g, () => Math.random().toString(16).substring(2, 4));

export const placeholder = args => `https://via.placeholder.com/${args || 150}`;

export const rem = num => `${parseInt(num.replaceAll('px','')) / 16}rem`.toString();
